export default "__VITE_ASSET__7ba59265__"